import React from 'react'
import Sidebar from '../Sidebar/Sidebar'
import Topbar from '../Topbar/Topbar'
import { Layout } from "antd";
import Footer from '../Footer/Footer';
const { Content } = Layout;

export default function MasterLayout(props) {
    const hideChrome = Boolean(props.hideChrome);

    return (
        <>
            {/* <div className="sidebar"> */}
                {/******************* 
                         @purpose :Sidebar Components
                        @Author : INIC
                        ******************/}
                {/* <Sidebar />
            </div> */}
            <Layout className={`site-layout ${hideChrome ? "site-layout--chrome-hidden" : ""}`}>
            
                <Content className="site-layout-background d-flex flex-column h-100">
                    {!hideChrome && (
                        <Topbar headerHide={props.headerHide} minimal={props.minimalHeader} />
                    )}

                    <div className={`middle-content-section ${hideChrome ? "middle-content-section--full" : ""}`}>
                        {props.children}
                    </div>

                    {!hideChrome && <Footer minimal={props.minimalHeader} />}
                </Content>
            </Layout>
        </>
    )
}
